<template>
  <div class="data-analysis">
    <Block class="access-data" title="访问数据">
      <Rank :rankTitle="accessTitle" :rank="visitRank" type="flow" />
    </Block>
    <Block
      v-if="goodsRankFlow.length > 0"
      class="flow-goods__rank"
      title="流量商品排行"
    >
      <Rank
        :rankTitle="flowTitle"
        :rank="goodsRankFlow"
        :btnGroup="btnGroup"
        type="sales"
      />
    </Block>
    <Block class="access-flow" title="访问流量">
      <div class="chart-line">
        <div class="chang-data">
          <el-button
            size="120 "
            round
            class="fff-color"
            :class="pvIndex === index && 'active'"
            v-for="(item, index) in accessFlowTitle"
            :key="item.title"
            @click="changePvChartData(item, index)"
          >
            {{ item.title }}
          </el-button>
        </div>
        <span class="time">
          {{ time }}
        </span>
        <chart-line
          v-bind="$attrs"
          :chartLineData="chartPvData"
          :legendVisible="false"
          :loading="$attrs.loading"
          :dataEmpty="chartPvData.rows && chartPvData.rows.length === 0"
          :chartLineSettings="chartLineSettings"
          height="32rem"
          :chartOptions="chartOptions"
          :dataZoom="dataZoom"
          :colors="['rgba(220, 196, 161, 0.3)']"
          :style="{ top: '6rem', padding: '0  2rem' }"
        />
      </div>
    </Block>
    <Block class="page-access__flow " title="页面访问流量">
      <ul class="list-item">
        <li class="item" v-for="(item, index) in sortVisitRank" :key="index">
          <span class="name">{{ item.name }}</span>
          <span class="block" :style="{ width: `${item.width}rem` }">
            <div class="progress"></div>
          </span>
          <span class="percentage">{{ item.percentage }}%</span>
          <span class="total">{{ item.num }}次访问</span>
        </li>
      </ul>
    </Block>
  </div>
</template>
<script>
import Block from '../components/Block/'
import Rank from '../components/Rank/'
import chartLine from 'components/Chart/Line/'

export default {
  name: 'flowData',
  components: {
    Block,
    Rank,
    chartLine
  },
  data() {
    this.accessTitle = ['ID', '访问城市', '访问时间', '访问IP', '访问路径']
    this.btnGroup = ['当天流量排行', '7天流量排行', '30天流量排行']
    this.flowTitle = ['排名', '商品名称', '流量']
    this.accessFlowTitle = [
      {
        title: '实时访问数据',
        search_mode: 'real_time',
        entry_mode: 'flow'
      },
      {
        title: '7天访问数据',
        search_mode: 'seven_day',
        entry_mode: 'flow'
      },
      {
        title: '30天访问数据',
        search_mode: 'thirty_day',
        entry_mode: 'flow'
      }
    ]
    this.dataZoom = [
      {
        type: 'slider',
        start: 0,
        end: 100,
        backgroundColor: 'rgba(220, 196, 161, 0.2)',
        handleStyle: {
          color: 'rgba(220, 196, 161, 1)'
        },
        fillerColor: 'rgba(220, 196, 161, .3)'
      }
    ]
    this.chartOptions = {
      tooltip: {
        axisPointer: {
          type: 'none'
        }
      }
    }
    this.chartLineSettings = {
      area: true,
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              // '#c23531','#2f4554', '#61a0a8',
              offset: 0,
              color: '#dcc4a1' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(220, 196, 161, 0.1)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      }
    }
    this.keyMap = {
      visit_list: {
        name: 'visitRank',
        access_city: 'city',
        access_ip: 'ip',
        access_path: 'path',
        add_time: 'time',
        visit_id: 'id'
      },
      visit_data: {
        name: 'chartPvData',
        subName: 'rows',
        date_time: '日期',
        visit_number: '访问用户',
        order_quantity: '下单用户',
        adds: [
          {
            name: 'columns',
            value: ['日期', '访问用户', '下单用户']
          }
        ]
      },
      goods_list: {
        name: 'goodsRankFlow',
        goods_id: 'id',
        goods_name: 'name',
        visit_number: 'num'
      },
      type_visit_data: {
        name: 'pageVisit',
        visit_type: 'name',
        visit_number: 'num',
        visit_proportion: 'percentage'
      }
    }
    return {
      visitRank: [],
      goodsRankFlow: [],
      chartPvData: {},
      pageVisit: [],
      time: '',
      pvIndex: 0
    }
  },
  created() {
    this._getFlowData()
  },
  computed: {
    /**
     * 页面访问数据排行
     * @returns {*}
     */
    sortVisitRank() {
      if (this.pageVisit.length > 0) {
        const rank = this.pageVisit
        // 从大到小排列数据
        rank.sort(this.utils._compare('num', 'des'))
        const radio = +rank[0].num // 取出第一条数据作为后续数据的一个参考值
        // 根据第一条数据算出每条数据所占比例 40.6 柱形为总长度 3作为最小长度
        rank.forEach((v, i) => {
          if (i === 0) {
            v.width = 40.6
          } else {
            const w = (+v.num / radio) * 40.6
            v.width = w < 3 ? 3 : w
          }
        })
        return rank
      }
    }
  },
  methods: {
    /**
     * 获取数据
     * @param params
     * @private
     */
    _getFlowData(params) {
      this.api.getFlowAnalyz(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.visitRank = res.visitRank
        this.goodsRankFlow = res.goodsRankFlow
        this.chartPvData = res.chartPvData
        this.pageVisit = res.pageVisit
        this.time = this.chartPvData.rows[0]['日期']
      })
    },
    /**
     * 切换访问流量
     */
    changePvChartData(params, index) {
      if (index >= 0) {
        this.pvIndex = index
      }
      this.api.changeData(params).then(res => {
        if (res.visit_data.length > 0) {
          if (params.search_mode === 'real_time') {
            this.time = new Date().toLocaleDateString().replace(/\//g, '-')
          } else {
            this.time = `${res.visit_data[0].date_time}~${
              res.visit_data.slice(-1)[0].date_time
            }`
          }
        }
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartPvData = res.chartPvData
      })
    }
  }
}
</script>
<style lang="scss">
.data-analysis {
  .access-data {
    width: 100%;
    height: 33.8rem;

    .hot-rank__list {
      padding: 4rem 7.8rem;
      text-align: left;
      overflow-y: hidden;
    }

    .rank-list {
      height: 100%;
    }

    .box {
      width: 100%;
      height: 100%;
    }

    .visible,
    .nav {
      padding: 0 2rem;
    }

    .visible {
      .item:first-child {
        margin-top: 0.5rem;
      }
    }

    .item {
      &:before {
        left: -2rem;
        width: 95%;
      }
    }
  }

  .flow-goods__rank {
    width: 100%;
  }

  .access-flow {
    width: 100%;
    height: 45.6rem;
  }

  .page-access__flow {
    width: 100%;
    min-height: 41.9rem;

    .list-item {
      padding: 6.4rem 0 6.4rem 9.1rem;
      .name {
        text-align: left;
      }
    }

    .item {
      &:nth-child(1) {
        .progress {
          background-color: #eb6580;
        }
      }

      &:nth-child(2) {
        .progress {
          background-color: #ce7cb1;
        }

        .percentage {
          background-color: #ce7cb1;
        }
      }

      &:nth-child(3) {
        .progress {
          background-color: #8b72b1;
        }

        .percentage {
          background-color: #8b72b1;
        }
      }

      &:nth-child(4) {
        .progress {
          background-color: #7ccce7;
        }

        .percentage {
          background-color: #7ccce7;
        }
      }

      &:nth-child(5) {
        .progress {
          background-color: #e7ae7c;
        }

        .percentage {
          background-color: #e7ae7c;
        }
      }

      &:nth-child(6) {
        .progress {
          background-color: #f2a069;
        }

        .percentage {
          background-color: #f2a069;
        }
      }

      &:nth-child(7) {
        .progress {
          background-color: #dcc4a1;
        }

        .percentage {
          background-color: #dcc4a1;
        }
      }
    }

    .block {
      width: 40.6rem;
    }

    .progress {
      border-radius: 0.9rem;
    }

    .percentage {
      width: 4.8rem;
      height: 1.9rem;
      background-color: #eb6580;
      border-radius: 0.9rem;
      text-align: center;
      line-height: 1.9rem;
      color: #fff;
    }

    .total {
      margin-left: 4rem;
    }
  }
}
</style>
